import { baseNationCollection } from "./baseNationCollection";

export const citizenshipCollection = [{ name: "Apolide", value: "Apolide" }, ...baseNationCollection];
export const citizenshipCollectionOptions = citizenshipCollection.map((citizenship) => ({
  [citizenship.value]: citizenship.name,
}));
